export default __webpack_public_path__ + "img/WB_RT.4cf4129dbbb8e9f6eb6e04429571a228.jpg";